// @ts-nocheck
import * as Types from '../../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type SelectBiddersStepQueryVariables = Types.Exact<{
  bidPackageGroupId: Types.Scalars['ID']['input'];
  costCodes: Array<Types.Scalars['ID']['input']> | Types.Scalars['ID']['input'];
}>;


export type SelectBiddersStepQuery = { __typename?: 'Query', bidPackageGroup: { __typename?: 'BidPackageGroup', id: string, bidPackages: Array<{ __typename?: 'BidPackage', id: string, name: string, costCodes: Array<{ __typename?: 'CostCode', id: string }> }> }, tradePartners: Array<{ __typename?: 'TradePartner', id: string, name: string, activeTasksCount: number, activeContractsCount: number, onboardingStatus: { __typename?: 'TradePartnerOnboardingStatusDetail', code: Types.TradePartnerOnboardingStatus, name: string }, costCodes: Array<{ __typename?: 'CostCode', id: string }> }> };

export type BidderBidPackageFragment = { __typename?: 'BidPackage', id: string, name: string, costCodes: Array<{ __typename?: 'CostCode', id: string }> };

export type TradePartnerBidderFragment = { __typename?: 'TradePartner', id: string, name: string, activeTasksCount: number, activeContractsCount: number, onboardingStatus: { __typename?: 'TradePartnerOnboardingStatusDetail', code: Types.TradePartnerOnboardingStatus, name: string }, costCodes: Array<{ __typename?: 'CostCode', id: string }> };

export const BidderBidPackageFragmentDoc = gql`
    fragment BidderBidPackage on BidPackage {
  id
  name
  costCodes {
    id
  }
}
    `;
export const TradePartnerBidderFragmentDoc = gql`
    fragment TradePartnerBidder on TradePartner {
  id
  name
  activeTasksCount
  activeContractsCount
  onboardingStatus {
    code
    name
  }
  costCodes {
    id
  }
}
    `;
export const SelectBiddersStepDocument = gql`
    query SelectBiddersStep($bidPackageGroupId: ID!, $costCodes: [ID!]!) {
  bidPackageGroup(id: $bidPackageGroupId) {
    id
    bidPackages {
      ...BidderBidPackage
    }
  }
  tradePartners(filter: {costCodes: $costCodes}) {
    ...TradePartnerBidder
  }
}
    ${BidderBidPackageFragmentDoc}
${TradePartnerBidderFragmentDoc}`;

/**
 * __useSelectBiddersStepQuery__
 *
 * To run a query within a React component, call `useSelectBiddersStepQuery` and pass it any options that fit your needs.
 * When your component renders, `useSelectBiddersStepQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSelectBiddersStepQuery({
 *   variables: {
 *      bidPackageGroupId: // value for 'bidPackageGroupId'
 *      costCodes: // value for 'costCodes'
 *   },
 * });
 */
export function useSelectBiddersStepQuery(baseOptions: ApolloReactHooks.QueryHookOptions<SelectBiddersStepQuery, SelectBiddersStepQueryVariables> & ({ variables: SelectBiddersStepQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SelectBiddersStepQuery, SelectBiddersStepQueryVariables>(SelectBiddersStepDocument, options);
      }
export function useSelectBiddersStepLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SelectBiddersStepQuery, SelectBiddersStepQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SelectBiddersStepQuery, SelectBiddersStepQueryVariables>(SelectBiddersStepDocument, options);
        }
export function useSelectBiddersStepSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SelectBiddersStepQuery, SelectBiddersStepQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<SelectBiddersStepQuery, SelectBiddersStepQueryVariables>(SelectBiddersStepDocument, options);
        }
export type SelectBiddersStepQueryHookResult = ReturnType<typeof useSelectBiddersStepQuery>;
export type SelectBiddersStepLazyQueryHookResult = ReturnType<typeof useSelectBiddersStepLazyQuery>;
export type SelectBiddersStepSuspenseQueryHookResult = ReturnType<typeof useSelectBiddersStepSuspenseQuery>;
export type SelectBiddersStepQueryResult = Apollo.QueryResult<SelectBiddersStepQuery, SelectBiddersStepQueryVariables>;